import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativePortionsNOV: typeof valueTypeRenderers.chillCumulativePortionsNOV = {
  label: () => unitConverter.chillCumulativePortionsNOV().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativePortionsNOV().title(),
      render: (n) => unitConverter.chillCumulativePortionsNOV(n).valueAsString(),
    }),
}
